// 引入request
import request from "@/utils/request";


//导航
export function nav() {
    return request({
      url: '/web/open/homepage/list',
      method: 'get',
  
    })
}


//意见反馈
export function submitFeedback(data) {
  return request({
    url: '/web/feedback/add',
    method: 'post',
    data:data,
  })
}

//热点词语
export function getWords() {
  return request({
    url: '/web/feedback/queryReadHotWord',
    method: 'get',
  })
}

//个人信息
export function getInformation(memberId) {
  return request({
    url: '/web/member/list/'+ memberId,
    method: 'get',
  })
}

//退出登录
export function outLogin() {
  return request({
    url: '/logout',
    method: 'post',
  })
}


//查询个人勋章
export function querySearchMedal(data) {
  return request({
    url: '/contest/selectMemberMedal',
    method: 'post',
    data:data
  })
}

//查询权限
export function queryLimitsAuthority(memberId) {
  return request({
    url: '/web/member/queryLimitsOfAuthority/'+memberId,
    method: 'get',
   
  })
}

// 收到的回复
export function getFeedbackList(data){
	return request({
		url:'/system/feedback/list',
		method:'get',
    params:data,
	})
}

// 添加登录日志信息
export function addLogininfor(data){
	return request({
		url:'/read/logininfor/add',
		method:'post',
    data:data,
	})
}

// 查询敏感词
export function sensitiveness(){
	return request({
		url:'/read/sensitiveness/list',
		method:'get',
	})
}
